import { OptionName, BillingInformation, Plan, Offer } from '@app/api';
import { franceCountryCodes, euCountries } from '../config/euCountries';
import { LazyProductArray, toProductArr } from './priceComputation';

export const hasProduct = (
  products: LazyProductArray,
  name: string,
): boolean => {
  return toProductArr(products).some((p) => p.name === name);
};

export const getMaxNumberOfQuestions = (
  products?: LazyProductArray,
  hasPlan?: boolean,
) => {
  if (products === undefined) {
    if (hasPlan) {
      return 0;
    }
    return -1;
  }

  if (hasProduct(products, OptionName.THREE_SCREENING_QUESTIONS)) {
    return 3;
  }
  if (hasProduct(products, OptionName.UNLIMITED_SCREENING_QUESTIONS)) {
    return -1;
  }
  return 0;
};

export const shouldApplyVatToBillingInfo = (info?: BillingInformation) => {
  if (!info || !info.billingAddress) {
    return true;
  }
  return shouldApplyVat(info.billingAddress.country);
};

export const shouldApplyVat = (countryKey: string) => {
  if (franceCountryCodes.includes(countryKey)) {
    return true;
  }
  return false;
};
